import React from 'react';
import { Grid, Stack, Button } from '@mui/material';

interface FormActionsProps {
  onCancel: () => void;
  isEdit: boolean;
}

export const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  isEdit
}) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {isEdit ? 'Update Contact' : 'Save Contact'}
        </Button>
      </Stack>
    </Grid>
  );
};